import { hydratePrefs, hydrateMetadata, persistPrefs } from 'api/third/thirdpreferences';

const persistCustomFieldsArrayType = (persistedData) => {
    return {
        id: persistedData.id,
        value: persistedData?.value?.map((cf) => cf.id) || [],
    };
};

const persistCustomFieldsRichTextType = (persistedData) => {
    return {
        id: persistedData.id,
        value: persistedData.value?.content || '',
    };
};

const persistCustomFieldsDefaultType = (persistedData) => {
    return {
        id: persistedData.id,
        value: persistedData.value,
    };
};

const persistCustomFieldsType = {
    array: persistCustomFieldsArrayType,
    richText: persistCustomFieldsRichTextType,
    default: persistCustomFieldsDefaultType,
};

const persistCustomFields = (fields) => {
    const data = [];
    let status = 'default';

    fields.forEach((cf) => {
        const persistedData = {
            id: cf.id,
            value: cf.value,
        };
        if (cf.type === 'rich-text') {
            status = 'richText';
        } else if (Array.isArray(cf.value)) {
            status = 'array';
        }
        data.push(persistCustomFieldsType[status](persistedData));
        status = 'default';
    });
    return data;
};

const getCompanyPreferences = async (companyId, type) => {
    try {
        const response = await ApiClient.get(`/${type}/${companyId}/preferences`);
        return new Promise((resolve) => resolve(hydratePrefs(response.data)));
    } catch (err) {
        Push.error(
            window.i18n.__('Une erreur est survenue lors de la récupération des préférences'),
        );
        throw new Error(err);
    }
};

const getMetadata = async () => {
    try {
        const response = await ApiClient.get('/companies/metadata');
        return new Promise((resolve) => resolve(hydrateMetadata(response.data)));
    } catch (err) {
        Push.error(
            window.i18n.__('Une erreur est survenue lors de la récupération de vos données'),
        );
        throw new Error(err);
    }
};

const updatePreferences = async (id, type, isSupplier, data) => {
    try {
        const response = await ApiClient.put(
            `/${type}/${id}/preferences`,
            {},
            persistPrefs(isSupplier, data),
        );
        return new Promise((resolve) => resolve(response));
    } catch (err) {
        Push.error(
            window.i18n.__("Une erreur est survenue lors de l'enregistrement de vos données"),
        );

        throw new Error(JSON.stringify(err.response));
    }
};

export { persistCustomFields, getCompanyPreferences, getMetadata, updatePreferences };
